"use client";

import { networkApi } from "@/apis";
import { MainLayout } from "@/components/layout/main-layout";
import { ModalProvider } from "@/components/modals/modal-provider";
import { AuthProvider } from "@/context/auth-context";
import store from "@/store";
import WagmiConfigProvider from "@/wagmi/WagmiConfigProvider";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";

export default function ClientProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  const [listNetwork, setListNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const pathname = usePathname();

  const getAllNetworks = async () => {
    try {
      setFetching(true);
      const res = await networkApi.getServerSideNetworks({ status: false });
      setListNetwork(res?.data);
      setFetching(false);
    } catch (e) {
      setListNetwork(null);
      setFetching(false);
    }
  };

  useEffect(() => {
    getAllNetworks();
    localStorage.setItem("path", pathname);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider>
        <Toaster />
        {!!listNetwork?.[0] && (
          <WagmiConfigProvider listNetwork={listNetwork}>
            <ModalProvider>
              <MainLayout>{children}</MainLayout>
            </ModalProvider>
          </WagmiConfigProvider>
        )}
      </AuthProvider>
    </Provider>
  );
}
